// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_MonthlyUsageResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for monthly invoice usage statistics
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Invoice_MonthlyUsageResponseDados {
franchise_id: number
year: number
month: number
count: number
limit?: number
remaining?: number
}

export type Invoice_MonthlyUsageResponse = ApiResponse<Invoice_MonthlyUsageResponseDados>;

registerResponseContract('Invoice_MonthlyUsageResponse', {
  franchise_id: { type: 'number',  required: true },
  year:         { type: 'number',  required: true },
  month:        { type: 'number',  required: true },
  count:        { type: 'number',  required: true },
  limit:        { type: 'number',  required: false },
  remaining:    { type: 'number',  required: false },
})
